var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2236 4.6L7.79961 0.176C7.6872 0.063446 7.53469 0.000140042 7.37561 0H3.79961C3.21613 0 2.65655 0.231785 2.24397 0.644365C1.83139 1.05694 1.59961 1.61652 1.59961 2.2V11.8C1.59961 12.3835 1.83139 12.9431 2.24397 13.3556C2.65655 13.7682 3.21613 14 3.79961 14H10.1996C10.7831 14 11.3427 13.7682 11.7552 13.3556C12.1678 12.9431 12.3996 12.3835 12.3996 11.8V5C12.3933 4.84928 12.3305 4.70647 12.2236 4.6ZM7.99961 2.048L10.3516 4.4H7.99961V2.048ZM10.1996 12.8H3.79961C3.53439 12.8 3.28004 12.6946 3.0925 12.5071C2.90497 12.3196 2.79961 12.0652 2.79961 11.8V2.2C2.79961 1.93478 2.90497 1.68043 3.0925 1.49289C3.28004 1.30536 3.53439 1.2 3.79961 1.2H6.79961V5C6.80168 5.15849 6.86556 5.3099 6.97764 5.42197C7.08971 5.53405 7.24112 5.59793 7.39961 5.6H11.1996V11.8C11.1996 12.0652 11.0943 12.3196 10.9067 12.5071C10.7192 12.6946 10.4648 12.8 10.1996 12.8Z",
    fill: "#768A9A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileIcon);
export default __webpack_public_path__ + "static/media/FileIcon.6b698b190e5becbd1fcc5d8b18ce24d0.svg";
export { ForwardRef as ReactComponent };